import React, {FC} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {random} from "../../../common/utils/function";

interface SponsorData {
    dark?: any,
    className?: any,
}

const Sponsor: FC<SponsorData> = (props) => {
    const {t, i18n} = useTranslation();
    const sponsor = useSelector((e: Object) => (e as any)?.common?.config?.sponsor?.[random(0, (e as any)?.common?.config?.sponsor?.length)]);

    return (
        <React.Fragment>
            {!!sponsor && <section className={props?.className}>
                <div className="pb-3">
                    <div className="d-flex text-muted">
                        <div style={props.dark ? {color: 'white', textDecoration: "none"} : {textDecoration: "none"}}>
                            <b className="fw-bold">{t("Featured")}:</b> &nbsp;
                            <img src={sponsor?.logo} height={12} style={{marginTop: "-3px"}}/>
                            &nbsp;- {sponsor?.title}:{sponsor?.description}
                            <a
                                href={sponsor?.link}
                                target="_blank"
                                rel="nofollow"
                                title={sponsor?.linkText}
                            >
                                <b> {sponsor?.linkText}</b>
                            </a>
                        </div>
                    </div>
                </div>
            </section>}
        </React.Fragment>
    );
};

export default Sponsor;
